import { render, staticRenderFns } from "./familyGraph.vue?vue&type=template&id=d2446c2c&scoped=true"
import script from "./familyGraph.vue?vue&type=script&lang=js"
export * from "./familyGraph.vue?vue&type=script&lang=js"
import style0 from "./familyGraph.vue?vue&type=style&index=0&id=d2446c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2446c2c",
  null
  
)

export default component.exports